(function () {
  function initBrandMarquee(root) {
    if (!root || root.dataset.marqueeReady === 'true') return;

    const track = root.querySelector('.dewberry-brand-directory__track');
    const list = track?.querySelector('.dewberry-brand-directory__list');
    if (!track || !list || !list.children.length) return;

    const clone = list.cloneNode(true);
    clone.removeAttribute('id');
    clone.setAttribute('aria-hidden', 'true');
    clone.querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', '-1'));
    track.appendChild(clone);
    root.dataset.marqueeReady = 'true';
  }

  function initAllBrandMarquees(scope) {
    (scope || document).querySelectorAll('[data-dewberry-brand-marquee]').forEach(initBrandMarquee);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllBrandMarquees(), { once: true });
  } else {
    initAllBrandMarquees();
  }

  document.addEventListener('shopify:section:load', (event) => initAllBrandMarquees(event.target));
})();
